import favoritesService from '@/services/favorites'

export default {
  namespaced: true,

  state: {
    sharingIds: '',
    socialText:
      'Estos son mis vídeos favoritos de la Conferencia Esri 2020 - #CEsri20',
  },

  mutations: {
    setSharingIds(state, ids) {
      state.sharingIds = ids
    },
  },

  actions: {
    setFavorite({ commit }, payload) {
      favoritesService.setFavorite(payload).then(res => {
        commit(
          'videos/updateVideoFavorite',
          { pk: res.video, status: res.is_favorite },
          { root: true }
        )
      })
    },

    fetchFavoritesList({ commit }) {
      favoritesService.getFavoritesList().then(res => {
        const videos = res.map(fav => fav.video)
        commit('videos/setVideosList', videos, { root: true })
        const idsArray = videos.map(video => video.pk)
        const ids = idsArray.join('-')
        commit('setSharingIds', ids)
      })
    },

    fetchSharedFavoritesList({ commit }, ids) {
      favoritesService.getSharedFavoritesList(ids).then(res => {
        commit('videos/setVideosList', res, { root: true })
      })
    },
  },
}
